import { Component, Fragment } from "react";
import { connect } from 'react-redux';
import { Link} from "react-router-dom";
import { exibeMensagemErro } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import api from "../../services/api";
import { getMessagemErro } from "../../utils/erro";

import './Home.css';
import { BoasVindas } from "./WelcomeMessage";
import { MensagemUsuarioAnonimo } from "./AnonimousUserMessage";
import { AumentaNivelGovBr } from "../AumentaNivelGovBr/AumentaNivelGovBr";

const mapDispatchToProps = { exibeMensagemErro, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user
	}
}

export const AnonimousPanel =

connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				usuario: {
					siape: undefined,
					cadastrado: undefined,
					podeProsseguir: undefined,
				},
			};
			
		}

		render() {
			const usuario = this.state.usuario;
			const mensagens = usuario?.mensagens?.map(m => <p>{m}</p>);

			return (
				<Fragment>
					<BoasVindas/>
					<AumentaNivelGovBr>
						<p><b>Atenção:</b> Para realizar o seu <b>cadastro na Plataforma do Conecta gov.br</b>, é necessário possuir uma conta <b>gov.br</b> com nível de confiabilidade <b>Prata ou Ouro</b>.</p><br/>
 					</AumentaNivelGovBr>

					{(this.props.user.nivelConfiabilidade === 'OURO' || this.props.user.nivelConfiabilidade === 'PRATA') &&
						<Fragment>
							<div className="painelAnonimo">
								{ usuario.cadastrado === true &&
									<MensagemUsuarioAnonimo>
										{mensagens}
									</MensagemUsuarioAnonimo>
								}
								{ usuario.cadastrado === false && usuario.siape === true &&
									<MensagemUsuarioAnonimo>
										<p>Para cadastro na Plataforma de Gestão do Conecta é necessário informar o CNPJ do seu órgão de exercício, seu email institucional e a sigla do órgão caso o mesmo ainda não esteja cadastrado na Plataforma.</p>
									</MensagemUsuarioAnonimo>
								}
								{ usuario.cadastrado === false && usuario.siape === false &&
									<MensagemUsuarioAnonimo>
										<p>A Plataforma de Gestão do Conecta é de uso exclusivo de órgãos da administração pública das esferas federal, estadual e municipal.</p>
										<p>Só prossiga com a solicitação de cadastramento caso seja servidor de órgão público de uma das esferas mencionadas acima.</p>
										<p>Para cadastrar seu órgão é preciso informar o CNPJ do órgão da administração pública para ser validado pela Plataforma. Caso seja aceito, preencher a sigla do órgão e selecionar a sua atribuição na Plataforma de Gestão: Diretor de TI, Responsável Técnico ou Gestor.</p>
									</MensagemUsuarioAnonimo>
								}
							</div>
							{ (usuario.cadastrado === false || usuario.podeProsseguir === true) &&
								<div className="painelAnonimo">
									<div className="br-form">
										<div className="actions-button">
											<div className="actions justify-content-start">
												<Link to="/user-self-registration"> 
													<div className="back-button">
														<button type="button" className="button is-primary">Prosseguir</button>
													</div>
												</Link>
											</div>
										</div>
									</div>
								</div>	
							}
						</Fragment>
					}
				</Fragment>
			);
		}

		componentDidMount(){
			if(this.props.user.nivelConfiabilidade === 'BRONZE') {
				return;
			}

			this.props.mostraAguardando();
			api.get('/api/auto-cadastro-usuario/dados-usuario')
				.then(response => { 
					const usuario = response.data;
					this.setState({ usuario }) 
					this.props.mostraAguardando();
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível consultar o servidor.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

	}
);